// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThankYou {
    flex-direction: column;
    padding: 32px 0;
    width: 100%;
    align-items: center;
}

.ThankYou-box {
    justify-content: center;
    flex-direction: column;
    align-items: center;
    max-width: 670px;
}

.ThankYou-title {
    align-items: center;
    justify-content: center;
}

.ThankYou-title span {
    color: var(--Color-Brand-Text-Highlight, #0027F9);
    text-align: center;
    font-family: var(--Font-Family-All-purpose, Poppins);
    font-size: 173.348px;
    font-style: normal;
    font-weight: 600;
    line-height: 110%; /* 190.683px */
    letter-spacing: -1.733px;
}

.ThankYou-title img {
    position: relative;
    z-index: 1;
    left: -16px;
}

.ThankYou-content {
    line-height: 100%;
    max-width: 700px;
    background: #fff;
    padding: 40px;
    border-radius: 32px;
}

.ThankYou-actions {
    flex-direction: row;
    gap: 24px;
    width: 100%;
    justify-content: center;
    margin-top: 32px;
}

@media screen and (max-width: 1024px) {
    .ThankYou-actions {
        flex-direction: column;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/ThankYou.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iDAAiD;IACjD,kBAAkB;IAClB,oDAAoD;IACpD,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,cAAc;IACjC,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".ThankYou {\n    flex-direction: column;\n    padding: 32px 0;\n    width: 100%;\n    align-items: center;\n}\n\n.ThankYou-box {\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    max-width: 670px;\n}\n\n.ThankYou-title {\n    align-items: center;\n    justify-content: center;\n}\n\n.ThankYou-title span {\n    color: var(--Color-Brand-Text-Highlight, #0027F9);\n    text-align: center;\n    font-family: var(--Font-Family-All-purpose, Poppins);\n    font-size: 173.348px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 110%; /* 190.683px */\n    letter-spacing: -1.733px;\n}\n\n.ThankYou-title img {\n    position: relative;\n    z-index: 1;\n    left: -16px;\n}\n\n.ThankYou-content {\n    line-height: 100%;\n    max-width: 700px;\n    background: #fff;\n    padding: 40px;\n    border-radius: 32px;\n}\n\n.ThankYou-actions {\n    flex-direction: row;\n    gap: 24px;\n    width: 100%;\n    justify-content: center;\n    margin-top: 32px;\n}\n\n@media screen and (max-width: 1024px) {\n    .ThankYou-actions {\n        flex-direction: column;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
